<div class="daily-summary-strip">
  <!-- Capacity group (truck/crew meters + event counts): the strip's LAST
       chunk — Ray's wrap order drops these to their own line first. -->
  <div class="summary-capacity-group" *ngIf="stats && isDayView">
    <!-- Capacity Section -->
    <div
      class="summary-item capacity-section"
      [pTooltip]="utilizationTooltip"
      tooltipStyleClass="wide-tooltip"
      tooltipPosition="bottom"
    >
      <div class="progress-container condensed inline-progress">
        <div class="progress-track truck-track">
          <div
            class="progress-bar truck-bar"
            [style.width.%]="truckUtilization"
          ></div>
          <span class="track-text">
            <i class="pi pi-truck"></i> {{ stats.actualTrucksUsed }}/{{ stats.truckCapacity }}
          </span>
        </div>
        <div class="progress-track crew-track">
          <div
            class="progress-bar crew-bar"
            [style.width.%]="crewUtilization"
          ></div>
          <span class="track-text">
            <i class="pi pi-users"></i> {{ stats.actualCrewUsed }}/{{ stats.crewCapacity }}
          </span>
        </div>
      </div>
    </div>

    <!-- Event Counts -->
    <div class="summary-item badges-section">
      <ng-container *ngFor="let type of stats.totalEventsByType">
        <div
          *ngIf="type.count > 0"
          class="event-count-item"
          title="{{ type.count }} {{ type.type | titlecase }} Events"
          pTooltip="{{ type.count }} {{ type.type | titlecase }} Events"
          tooltipPosition="bottom"
          (click)="onFilter(type.type)"
        >
          <span
            class="dot"
            [style.background-color]="getEventTypeColor(type.type)"
          ></span>
          <span class="count">{{ type.count }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Money group ($$$ + forecast + pacing): wraps after the date controls
       and the small icons but BEFORE the capacity group above. The forecast
       and pacing branches require stats — without them the group renders
       EMPTY and the narrow controls bar gives it a full-height row above
       the skeleton (CodeRabbit). -->
  <div
    class="summary-money-group"
    *ngIf="totalRevenue > 0 || stats"
  >
    <!-- Month View Total / Forced Revenue -->
    <div
      class="summary-item revenue-section"
      *ngIf="forceShowRevenue && totalRevenue > 0"
      title="Total Revenue for current view"
    >
      {{ totalRevenue / 100 | currency }}
    </div>

    <!-- Revenue shown in day view (in-flow, after the counts). $0 days
         show "$0.00" so "loaded but empty" can't be mistaken for loading
         (Ray). -->
    <div
      class="summary-item revenue-section"
      *ngIf="stats && !forceShowRevenue"
      title="Total Revenue for current view"
    >
      {{ totalRevenue / 100 | currency }}
    </div>

    <!-- Forecast Section -->
    <app-forecast-card
      *ngIf="stats && showForecast"
      layout="strip"
      [showForecast]="true"
      [forecast]="stats.prophet"
      [date]="stats.date"
      [actualJobs]="actualMovingJobs"
      [actualTrucksUsed]="stats.actualTrucksUsed"
      [truckCapacity]="stats.truckCapacity"
      [actualCrewUsed]="stats.actualCrewUsed"
      [crewCapacity]="stats.crewCapacity"
      [prophetMetrics]="prophetMetrics"
    ></app-forecast-card>

    <!-- Pacing Section -->
    <app-pacing-card
      *ngIf="stats && showPacing"
      layout="strip"
      [pacing]="stats.pacing"
      [actualRevenue]="stats.totalRevenue"
      [allDays]="allDays"
    ></app-pacing-card>
  </div>

  <!-- Loading state: mirrors the real strip so the skeleton-to-data swap
       doesn't jump (Ray) — a capacity meter chunk with a count ghost, then
       the money boxes, all at control height. -->
  <div class="skeleton-wrapper" *ngIf="!stats">
    <div class="skel-capacity">
      <p-skeleton width="15rem" height="2.357rem" borderRadius="8px"></p-skeleton>
      <p-skeleton width="3.5rem" height="2.357rem" borderRadius="8px"></p-skeleton>
    </div>
    <div class="skel-money">
      <p-skeleton width="6.5rem" height="2.357rem" borderRadius="8px"></p-skeleton>
      <p-skeleton width="8rem" height="2.357rem" borderRadius="8px"></p-skeleton>
    </div>
  </div>
</div>

<!-- Utilization tooltip (Ray): richer than the raw percentages the native
     title used to give — same ng-template pattern as forecast/pacing.
     The tooltip renders a row per meter plus how utilization is meant to
     be read. -->
<ng-template #utilizationTooltip>
    <div class="utilization-tooltip-content">
        <div class="tooltip-header">Utilization</div>
        <div class="tooltip-row">
            <strong><i class="pi pi-truck"></i> Trucks</strong>
            <span>{{ stats.actualTrucksUsed }} of {{ stats.truckCapacity }} used ·
                {{ truckBookedPercent }}% booked</span>
        </div>
        <div class="tooltip-row">
            <strong><i class="pi pi-users"></i> Crew</strong>
            <span>{{ stats.actualCrewUsed }} of {{ stats.crewCapacity }} used ·
                {{ crewBookedPercent }}% booked</span>
        </div>
        <div class="tooltip-row" *ngIf="crewRequiredExtra > 0">
            <strong>Crew required</strong>
            <span>{{ crewRequiredExtra }} more scheduled than assigned — the
                crew meter fills to {{ maxCrewUsed }} of {{ stats.crewCapacity }}</span>
        </div>
        <div class="tooltip-divider"></div>
        <div class="tooltip-row">
            <strong>Busiest meter</strong>
            <span>{{ maxSystemUtilization | number:'1.0-0' }}% of capacity in use</span>
        </div>
        <small class="tooltip-hint">
            Meters fill with how much of today's truck and crew capacity is already scheduled.
        </small>
    </div>
</ng-template>